var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_filtered && !_vm.papelera)?_c('b-button',{staticClass:"m-l-10",attrs:{"id":"btn_restart_filter","variant":"outline-success"},on:{"click":_vm.restartSearch}},[_c('i',{staticClass:"icon-history"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }